import React from 'react';
import { motion } from 'framer-motion';

// Partner logo data - using placeholder company names for healthcare/transportation sector
const partners = [
  { name: 'HealthFirst', category: 'Healthcare' },
  { name: 'TransMed', category: 'Transportation' },
  { name: 'CareConnect', category: 'Healthcare' },
  { name: 'FleetPro', category: 'Transportation' },
  { name: 'MediRide', category: 'Healthcare' },
  { name: 'SafeTrip', category: 'Transportation' },
  { name: 'WellPath', category: 'Healthcare' },
  { name: 'DriveHealth', category: 'Transportation' },
];

export const PartnerLogosSection = () => {
  return (
    <section className="py-16 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-sm font-mono text-neon-cyan uppercase tracking-wider mb-2">
            Trusted By Industry Leaders
          </p>
          <h3 className="text-xl text-slate-400">
            Powering healthcare transportation across the nation
          </h3>
        </motion.div>

        {/* Logo Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-8 items-center">
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="flex items-center justify-center group"
            >
              <div className="relative px-4 py-3 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 cursor-default">
                {/* Stylized Logo Placeholder */}
                <div className="flex flex-col items-center">
                  <span className={`text-lg font-heading font-bold ${
                    partner.category === 'Healthcare' 
                      ? 'text-neon-cyan' 
                      : 'text-neon-purple'
                  } group-hover:text-white transition-colors`}>
                    {partner.name}
                  </span>
                  <span className="text-[10px] text-slate-500 uppercase tracking-wider">
                    {partner.category}
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8"
        >
          <div className="text-center">
            <div className="text-3xl font-heading font-bold text-white">500+</div>
            <div className="text-sm text-slate-500">Healthcare Partners</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-heading font-bold text-neon-cyan">12K+</div>
            <div className="text-sm text-slate-500">Active Drivers</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-heading font-bold text-neon-purple">247</div>
            <div className="text-sm text-slate-500">Cities Covered</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-heading font-bold text-neon-green">99.2%</div>
            <div className="text-sm text-slate-500">On-Time Rate</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerLogosSection;
